'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _constants = require('./constants');

var _constants2 = _interopRequireDefault(_constants);

var _util = require('./util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Router = function () {
    function Router(routes, options) {
        _classCallCheck(this, Router);

        // Set options
        this._customOptions = options;

        // set parent to null
        this._parent = null;

        var defaultRoutes = this.defaultRoutes || this.constructor.defaultRoutes;

        if (defaultRoutes) {
            (0, _util.bindResources)(defaultRoutes, this);
        }

        // Set routes
        if (routes) {
            (0, _util.bindResources)(routes, this);
        }
    }

    _createClass(Router, [{
        key: 'getCookies',
        value: function getCookies() {
            return _extends({}, this._parent ? this._parent.getCookies() : {});
        }
    }, {
        key: '_setParent',
        value: function _setParent(parent) {
            this._parent = parent;
        }
    }, {
        key: 'parent',
        get: function get() {
            return this._parent;
        }
    }, {
        key: 'isBound',
        get: function get() {
            return !!this._parent || !!this._options;
        }
    }, {
        key: 'options',
        get: function get() {
            if (!this._options) {
                this._options = (0, _util.mergeOptions)(_constants2.default, this._parent ? this._parent.options : null, this.defaultOptions || this.constructor.defaultOptions || null, this._customOptions);
            }

            return this._options;
        }
    }]);

    return Router;
}();

exports.default = Router;


//////////////////
// WEBPACK FOOTER
// ../~/tg-resources/dist/router.js
// module id = 773
// module chunks = 0